import { useState } from "react";
import { ImageBroken } from "@phosphor-icons/react";
import { Pill } from "@/components/admin/AdminUI";

export const REVIEW_TYPES = [
  { key: "all", label: "All" },
  { key: "onboarding_verification", label: "Onboarding verification" },
  { key: "phone_change", label: "Phone change" },
];

export function TypePill({ r }) {
  const onboarding = r.type === "onboarding_verification";
  const label = onboarding ? "Onboarding verification" : r.kind === "recovery" ? "Account recovery" : "Phone change";
  return <Pill tone={onboarding ? "brand" : "neutral"} data-testid={`review-type-${r.id}`}>{label}</Pill>;
}

// Image tile with a calm fallback when the file is missing or the signed link expired.
export function MediaTile({ src, alt, label, className = "", testId }) {
  const [broken, setBroken] = useState(!src);
  return (
    <figure className={`min-w-0 ${className}`}>
      {broken ? (
        <div className="cw-muted flex aspect-square w-full flex-col items-center justify-center gap-2 rounded-2xl bg-[var(--cw-surface-tertiary)] text-xs" data-testid={testId ? `${testId}-missing` : undefined}>
          <ImageBroken size={24} aria-hidden />Unavailable
        </div>
      ) : (
        <img src={src} alt={alt} onError={() => setBroken(true)} loading="lazy"
          className="aspect-square w-full rounded-2xl bg-[var(--cw-surface-tertiary)] object-cover" data-testid={testId} />
      )}
      {label && <figcaption className="cw-muted mt-1.5 text-xs">{label}</figcaption>}
    </figure>
  );
}
